module.exports = __webpack_public_path__ + "img/parcelManLeft.671f6a92.svg";